/** Every named room surface. Which ones exist depends on the room shape (see ROOM_FACES). */
export const FACES = ['floor', 'ceiling', 'west', 'east', 'north', 'south', 'wall', 'core'] as const
export type Face = (typeof FACES)[number]

export type RoomShape = 'box' | 'round' | 'ring' | 'polygon'

export const ROOM_FACES: Record<RoomShape, readonly Face[]> = {
  box: ['floor', 'ceiling', 'west', 'east', 'north', 'south'],
  round: ['floor', 'ceiling', 'wall'],
  ring: ['floor', 'ceiling', 'wall', 'core'],
  polygon: ['floor', 'ceiling', 'wall'],
}
